import { DodajSlownikModel } from "./dodajSlownikModel";

export class EdytujSlownikModel extends DodajSlownikModel {
    id: string;
    czyNowyPlik: boolean;
}